module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-barbara.6c3d2101.svg";